<template>
  <footer class="footer py-3 mt-auto">
    <div class="container">
      <p class="float-end mb-1 to-top-botton" >
        <a href="#" class="text-white">返回顶部</a>
      </p>
      <p class="text-white text-center  mb-2">微纳制造数字化协同平台</p>
      <p class="text-white text-center"> Copyright © 2024 微纳制造创新中心 <a href="https://beian.miit.gov.cn" class="point-curser" target="_blank">鲁ICP备2021016150号-4</a></p>

<!--      <p class="mb-0">想进一步了解我们? <a href="/">访问</a> or read our <a href="/docs/5.3/getting-started/introduction/">getting started guide</a>.</p>-->
    </div>
  </footer>
</template>

<script setup>

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.to-top-botton{
  display: block;
  @media (max-width: 992px) {
    display: none !important;
  }
}
.footer{
  background: #213d69;
}



</style>
